import React, { forwardRef, LegacyRef } from 'react'

import styles from '../style.module.less'
import { BaseIconProps } from '../types'

export const AddWithBorder = forwardRef(
  (
    { _width, _height, _fill, className, spin, rtl, ...rest }: BaseIconProps,
    root: LegacyRef<SVGSVGElement>
  ) => {
    return (
      <svg
        ref={root}
        width={_width}
        height={_height}
        viewBox="0 0 48 48"
        preserveAspectRatio="xMidYMid meet"
        fill="none"
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ''} ${spin ? styles.spin : ''} ${
          rtl ? styles.rtl : ''
        }`.trim()}
        {...rest}
      >
        <g>
          <defs>
            <clipPath id="d3b27__a">
              <rect
                rx="0"
                height="48"
                width="48"
              />
            </clipPath>
          </defs>
          <g clipPath="url(#d3b27__a)">
            <path
              fillRule="evenodd"
              d="M4.5 8v6a1.5 1.5 0 0 0 3 0V8q0-.207.146-.354Q7.793 7.5 8 7.5h6a1.5 1.5 0 0 0 0-3H8q-1.45 0-2.475 1.025Q4.5 6.55 4.5 8ZM21 4.5h6a1.5 1.5 0 0 1 0 3h-6a1.5 1.5 0 0 1 0-3ZM40.5 14V8q0-.207-.146-.354Q40.207 7.5 40 7.5h-6a1.5 1.5 0 0 1 0-3h6q1.45 0 2.475 1.025Q43.5 6.55 43.5 8v6a1.5 1.5 0 0 1-3 0Zm-15 11.5V32a1.5 1.5 0 0 1-3 0v-6.5H16a1.5 1.5 0 0 1 0-3h6.5V16a1.5 1.5 0 0 1 3 0v6.5H32a1.5 1.5 0 0 1 0 3h-6.5ZM7.5 21v6a1.5 1.5 0 0 1-3 0v-6a1.5 1.5 0 0 1 3 0ZM42 19.5a1.5 1.5 0 0 1 1.5 1.5v6a1.5 1.5 0 0 1-3 0v-6a1.5 1.5 0 0 1 1.5-1.5ZM7.5 40v-6a1.5 1.5 0 0 0-3 0v6q0 1.45 1.025 2.475Q6.55 43.5 8 43.5h6a1.5 1.5 0 0 0 0-3H8q-.207 0-.354-.146Q7.5 40.207 7.5 40Zm36-6v6q0 1.45-1.025 2.475Q41.45 43.5 40 43.5h-6a1.5 1.5 0 0 1 0-3h6q.207 0 .354-.146.146-.147.146-.354v-6a1.5 1.5 0 0 1 3 0Zm-24 8a1.5 1.5 0 0 1 1.5-1.5h6a1.5 1.5 0 0 1 0 3h-6a1.5 1.5 0 0 1-1.5-1.5Z"
              data-follow-fill="#455766"
              fill={_fill}
            />
          </g>
        </g>
      </svg>
    )
  }
)
